<template>
    <footer>
        <p>&copy; <strong>{{ year }} Afrihost.</strong> All rights reserved.</p>
    </footer>
</template>

<script>
    export default {
        computed: {
            year() {
                return (new Date()).getFullYear();
            }
        }
    }
</script>